import "google-fonts";
import "regenerator-runtime/runtime";


import ChatBot from "./component/chatbot/ChatBot.jsx";
import React, { useRef, useState, useEffect } from "react";
import "./App.css";
import { db } from "./config/firebase";

import { getDoc, doc } from "firebase/firestore";

function App() {
  const [float_visible, setfloat_Visible] = useState(true);

  const [imageUrl, setImageUrl] = useState();
  const [title, setTitle] = useState();
  const [defualtMessages, setDefualtMessages] = useState([]);
  const [submenu,setSubmenu]=useState([]);
  console.log("visible=", float_visible);
  const urlParams = new URLSearchParams(window.location.search);
  const currentDomain = urlParams.get("parentUrl");
  console.log("-----------------------------------------------", currentDomain, "--------------------------------------");
  const shopId = currentDomain || "null";

  useEffect(() => {
    const fetchImage = async () => {
      try {
        // Replace `collectionName` and `documentId` with your Firestore structure
        const docRef = doc(db, "Shopify", shopId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setImageUrl(docSnap.data().Avatar_Link || "https://firebasestorage.googleapis.com/v0/b/open-source-28ce5.appspot.com/o/whatsapp-media%2Fbot.png?alt=media&token=dee0144e-14ca-4e2d-99e8-ad03a6618559");
          setTitle(docSnap.data()?.Botname || "");
          const submenu=docSnap.data()?.Submenu??[]
          const actionButtons=docSnap.data()?.ActionButtons ?? {}
          // {"Suggest skin care routine for men!":"Suggest skin care routine for men!","Suggest some best concealer":"Suggest some best concealer", "Mujhe dark spots remove karne hain":"Mujhe dark spots remove karne hain"}
          // {"Want to explore our bestsellers ?":"Show me your bestsellers","Want to customise a trip ?":"I want a custom trip"};
          setDefualtMessages(actionButtons)
          setSubmenu(submenu)
          const all_colors = docSnap.data()?.Color_Theme || {};
          const headerbackground = all_colors.primaryColor ?? "#dcf2d9";
          const headertext = all_colors.textSecondaryColor ?? "#000000";
          const bubble_user = all_colors.secondaryColor ?? "#3b892e";
          const send_button = all_colors.buttonTextColor ?? "#000";
          const footercolor = all_colors.primaryColor ?? "#5c583b";
          const textcolor = all_colors.textPrimaryColor ?? "#000000";
          const primarycolor = all_colors.primaryColor ?? "#000000";
          const accentColor = all_colors.accentColor ?? "#3b892e";
          const bubble_Sender = all_colors.bubble_Sender ?? "#000";
          // const bubblecolor=all_colors.
          console.log("Hello", textcolor);
          const wholesectionbackground = all_colors.backgroundColor ?? "#fff";

          document.documentElement.style.setProperty("--color-text", textcolor);
          document.documentElement.style.setProperty("--color-bubble", bubble_user);
          document.documentElement.style.setProperty("--color-header", headerbackground);
          document.documentElement.style.setProperty("--color-footer", footercolor);
          document.documentElement.style.setProperty("--color-headertext", headertext);
          document.documentElement.style.setProperty("--color-primary1", primarycolor);
          document.documentElement.style.setProperty("--color-buttontext", send_button);
          document.documentElement.style.setProperty("--color-buttonbackground", accentColor);
          document.documentElement.style.setProperty("--color-chatbackground", wholesectionbackground);
          document.documentElement.style.setProperty("--color-bubbletext", bubble_Sender);
          console.log(
            "Hey=",
            headerbackground,
            "Hey=",
            headertext,
            "Hey=",
            bubble_user,
            send_button,
            footercolor,
            "Hey=",
            textcolor,
            primarycolor,
            accentColor
          );
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching image: ", error);
      }
    };

    fetchImage();
  }, []);

return (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      zIndex: 10,
      display: 'block',
    }}
    className="krunk-bg-transparent"
  >
    <div className="krunk-flex krunk-justify-end krunk-items-end krunk-h-full krunk-bg-transparent">
      {/* Remove height full from inner div and add max-height */}
      <div className="krunk-flex krunk-flex-col krunk-h-full md:krunk-h-auto krunk-w-full krunk-max-w-md">
        <ChatBot 
          imageurl={imageUrl} 
          subMenu={submenu} 
          title={title} 
          actionButtons={defualtMessages} 
          setfloat_Visible={setfloat_Visible} 
          float_visible={float_visible}
        />
      </div>
    </div>
  </div>
);
}

export default App;
